<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：定制栏目-添加
    -->
  <el-dialog title="添加栏目" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" :model="form" :rules="formRules" ref="form">
      <el-form-item label="栏目类型" prop="fodder_type" :label-width="formLabelWidth">
        <el-radio-group v-model="form.fodder_type" @change="change">
          <!-- <el-radio :label="0">普通栏目</el-radio> -->
          <el-radio :label="1">酒体</el-radio>
          <el-radio :label="2">盒型</el-radio>
          <el-radio :label="3">瓶型</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="栏目名称" prop="fodder_name" :label-width="formLabelWidth">
        <el-input v-model="form.fodder_name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="所属分类" prop="category_id" :label-width="formLabelWidth" v-if="form.fodder_type == 0">
        <el-select v-model="form.category_id">
          <el-option :value="cat.category_id" :label="cat.name" :key="cat.category_id" v-for="cat in tableData" v-if="cat.type == 0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属分类" prop="category_id" :label-width="formLabelWidth" v-if="form.fodder_type == 1">
        <el-select v-model="form.category_id">
          <el-option :value="cat.category_id" :label="cat.name" :key="cat.category_id" v-for="cat in tableData" v-if="cat.type == 1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属盒型" prop="parent_id" :label-width="formLabelWidth" v-if="form.fodder_type == 3">
        <el-select v-model="form.parent_id">
          <el-option :value="cat.fodder_id" :label="cat.fodder_name" :key="cat.fodder_id" v-for="cat in fodderList" v-if="cat.fodder_type == 2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="栏目图片" prop="image_id" :label-width="formLabelWidth">
        <el-row>
          <el-button type="primary" @click="openUpload">选择图片</el-button>
          <div v-if="form.image_id!=''" class="img">
            <img :src="file_path" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="价格" prop="fodder_price" :label-width="formLabelWidth">
        <el-input type="number" v-model="form.fodder_price" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="酒体说明" prop="instruction" :label-width="formLabelWidth" v-if="form.fodder_type == 1">
        <el-input v-model="form.instruction" type="textarea" rows="5" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="是否显示" prop="no_show" :label-width="formLabelWidth">
        <el-radio-group v-model="form.no_show">
          <el-radio :label="0">显示</el-radio>
          <el-radio :label="1">不显示</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addUser" :loading="loading">确 定</el-button>
    </div>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
  </el-dialog>

</template>

<script>
  import CustomizationApi from '@/api/customization.js';
  import Upload from '@/components/file/Upload';
  export default {
    components: {
      Upload
    },
    data() {
      return {
        form: {
          fodder_type: 1,
          fodder_name: '',
          image_id: '',
          category_id: '',
          fodder_price: '',
          instruction: '',
          no_show: 0
        },
        formRules: {
          fodder_name: [{
            required: true,
            message: '请输入栏目名称',
            trigger: 'blur'
          }],
          image_id: [{
            required: true,
            message: '请上传栏目图片',
            trigger: 'blur'
          }],
          fodder_price: [{
            required: true,
            message: '请输入栏目价格',
            trigger: 'blur'
          }],
        },
        /*列表数据*/
        tableData: [],
        /*列表数据*/
        fodderList: [],
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        loading: false,
        /*是否上传图片*/
        isupload: false,
      };
    },
    props: ['open_add', 'addform'],
    created() {
      this.dialogVisible = this.open_add;
      // this.fodderList = this.addform.fodderList;
      // console.log(this.fodderList);
      this.getData();
    },
    methods: {
      /*获取列表*/
      getData() {
        let self = this;
        CustomizationApi.getCatList({}, true)
          .then(data => {
            self.tableData = data.data.list;
            self.fodderList = data.data.fodder.data;
          })
          .catch(error => {
          });
      },
      change() {
        this.form.category_id = '';
      },
      /*添加用户*/
      addUser() {
        let self = this;
        let params = self.form;
        if ((params.fodder_type == 0 || params.fodder_type == 1) && params.category_id == '') {
          this.$message({
            message: '请确认所属分类',
            type: 'error'
          });
          return false;
        }
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            CustomizationApi.fodderAdd(params).then(data => {
              self.loading = false;
              self.$message({
                message: '添加成功',
                type: 'success'
              });
              self.dialogFormVisible(true);
            }).catch(error => {
              self.loading = false;
            });
          }
        });
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
      /*上传*/
      openUpload(e) {
        this.type = e;
        this.isupload = true;
      },
      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null && e.length > 0) {
          this.file_path = e[0].file_path;
          this.form.image_id = e[0].file_id;
        }
        this.isupload = false;
      },

    }
  };
</script>

<style>
 .img {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/customization/fodder/Add.vue